import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import { sendStkPush } from "../../redux/actions/paymentActions";
import { paymentActions } from "../../redux/slices/payment";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { StkPushRequestDto } from "../../shared/dtos/payment/StkPushRequestDto";

interface StkPushModalProps {
  open: boolean;
  onClose: () => void;
  defaultAmount?: string | number;
  defaultPhone?: string;
  referencePrefix?: string;
}

const StkPushModal: React.FC<StkPushModalProps> = ({
  open,
  onClose,
  defaultAmount,
  defaultPhone,
  referencePrefix = "STK",
}) => {
  const dispatch = useAppDispatch();

  const { loadingStkPush, serverStatus } = useAppSelector(
    (state) => state.payment,
  );

  const [phone, setPhone] = useState<string>(defaultPhone || "");
  const [amount] = useState<string | number>(defaultAmount || "");

  useEffect(() => {
    if (
      serverStatus?.operation === "stk.push" &&
      serverStatus?.status === 200
    ) {
      dispatch(paymentActions.setServerStatus(null));
      onClose();
    }
  }, [serverStatus, dispatch, onClose]);

  const handleSubmit = (): void => {
    if (!phone || !amount) return;

    const payload: StkPushRequestDto = {
      amount: Number(amount),
      phoneNumber: phone,
      clientReference: `${referencePrefix}-${Date.now()}`,
      description: "POS Payment",
    };

    dispatch(sendStkPush(payload));
  };

  return (
    <Dialog
      open={open}
      onClose={loadingStkPush ? undefined : onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Send M-Pesa STK Push</DialogTitle>
      <DialogContent>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", mb: 3, mt: 1 }}
        >
          The customer will receive a prompt on their phone to enter their
          M-Pesa PIN. Once paid, use the &quot;Link Payment&quot; button to
          attach it to this receipt.
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Phone Number"
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="e.g. 2547XXXXXXXX"
            disabled={loadingStkPush}
          />
          <TextField
            label="Amount"
            type="number"
            fullWidth
            value={amount}
            disabled // Kept disabled so cashier doesn't accidentally change the exact cart amount
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={loadingStkPush}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          disabled={loadingStkPush || !phone}
        >
          {loadingStkPush ? "Sending..." : "Send Prompt"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StkPushModal;
